import {
  completedKey,
  executeKey,
  ExecuteType,
  failureKey,
  FailureType,
  successKey,
} from '@app/core/store/_prototypes/action-reducers/actions/helper';
import { ParameterType } from '@app/core/store/_prototypes/action-reducers/actions/parameter-type.interface';
import { ActionCreator, createAction, props, Action } from '@ngrx/store';
import { CheckedError } from '@app/core/errors/errors/checked-error.interface';

export const createLoadActions = <Key extends object, T>(
  type: string,
  loadParameters: ParameterType<Key>
): LoadActions<Key, T> => ({
  load: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    execute: createAction(executeKey(type, 'load'), loadParameters),
    success: createAction(successKey(type, 'load'), props<{ data: T; loaded: Key }>()),
    completed: createAction(completedKey(type, 'load')),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    failure: createAction(failureKey(type, 'load'), props<{ error: CheckedError }>()),
  },
});

export interface LoadActions<Key extends object, T> {
  load: {
    execute: ExecuteType<string, Key>;
    success: ActionCreator<string, (props: { data: T; loaded: Key }) => { data: T; loaded: Key } & Action<string>>;
    completed: ActionCreator<string, () => Action<string>>;
    failure: FailureType<string>;
  };
}
